module.exports = __webpack_public_path__ + "img/558.fafa5af9.png";